import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7f10cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "filters-initial-loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-text" }, "Chargement des filtres...", -1))
const _hoisted_3 = {
  key: 1,
  class: "tw-saved-filters modern-saved-filters"
}
const _hoisted_4 = ["data-filter-id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_FilterButton = _resolveComponent("FilterButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showInitialLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_spinner_dots, {
            size: "32px",
            color: "primary"
          }),
          _hoisted_2
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "tw-saved-filters-inner modern-filters-grid",
            style: _normalizeStyle(_ctx.gridStyle)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfFilters, (filter, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: filter.resourceUid || index
              }, [
                (_ctx.isAuthorized(_ctx.userAuthorities, filter.groupFilter?.items) || _ctx.isAdmin)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tw-saved-filters-box modern-filter-card",
                      "data-filter-id": filter.resourceUid
                    }, [
                      _createVNode(_component_FilterButton, {
                        filter: filter,
                        connectedUser: _ctx.connectedUser,
                        index: index,
                        batchComplete: _ctx.batchCountComplete,
                        isAdmin: _ctx.isAdmin,
                        onClick: ($event: any) => (_ctx.onSelectedFilter(filter)),
                        onDelete: ($event: any) => (_ctx.onDeleteFilter(filter)),
                        onEdit: ($event: any) => (_ctx.onEditFilter(filter))
                      }, null, 8, ["filter", "connectedUser", "index", "batchComplete", "isAdmin", "onClick", "onDelete", "onEdit"])
                    ], 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 4)
        ]))
  ]))
}